import React from 'react';
import { FaBalanceScale } from 'react-icons/fa';
import { Section, SectionTitle, InfoGrid, InfoItem } from './ProfileStyles';

/**
 * Situação da inscrição na OAB. `tipoInscricao`/`situacaoOAB` vêm como
 * { id: null, descricao: null } quando a pessoa não está inscrita na OAB
 * ou não tem cadastro de Pessoa vinculado ao login.
 *
 * @param {Object} props.tipoInscricao - { id, descricao }
 * @param {Object} props.situacaoOAB - { id, descricao }
 */
export const OABStatus = ({ tipoInscricao, situacaoOAB }) => {
  const isInscrito = !!(tipoInscricao?.descricao || situacaoOAB?.descricao);

  return (
    <Section>
      <SectionTitle>
        <FaBalanceScale /> Inscrição na OAB
      </SectionTitle>

      {isInscrito ? (
        <InfoGrid>
          <InfoItem>
            <label>Tipo de Inscrição</label>
            <span>{tipoInscricao?.descricao || 'Não informado'}</span>
          </InfoItem>

          <InfoItem>
            <label>Situação</label>
            <span>{situacaoOAB?.descricao || 'Não informado'}</span>
          </InfoItem>
        </InfoGrid>
      ) : (
        <InfoGrid>
          <InfoItem>
            <span>Não inscrito na OAB</span>
          </InfoItem>
        </InfoGrid>
      )}
    </Section>
  );
};
